export default __webpack_public_path__ + "static/media/checkbox-unselected.687676f6.svg";